//#region Time
const monthNamesThai = [
  'มกราคม',
  'กุมภาพันธ์',
  'มีนาคม',
  'เมษายน',
  'พฤษภาคม',
  'มิถุนายน',
  'กรกฎาคม',
  'สิงหาคม',
  'กันยายน',
  'ตุลาคม',
  'พฤษจิกายน',
  'ธันวาคม',
];
export const getThaiMonth = (month: number) => {
  return monthNamesThai[month];
};
export const convertADtoBEYear = (year: number) => {
  return year + 543;
};
//#endregion
